<template>
  <div>
    <div class="right-cart-container">
      <ul class="right-cart-box">
        <li class="mini-cart" @click="handleCart">
          <div>
            <span class="right-cart-number">{{ cartNum }}</span>
            <svg-icon icon-class="shopping" class-name="zp-icon icon-pic" />
            <span class="line-text">购物车</span>
          </div>
        </li>
        <!-- <li class="parts-basket" @click="handleBasket">
					<div>
						<svg-icon icon-class="peijianlan" class-name="right-basket-icon" />
						<span class="line-text">配件篮</span>
					</div>
				</li> -->
        <!-- <li @click="handleMessage">
					<svg-icon icon-class="message" />
					<h3>消息</h3>
				</li> -->
        <li @click="handleContact">
          <a
            target="_blank"
            class="qq"
            href="http://wpa.qq.com/msgrd?v=3&uin=2086681945&site=qq&menu=yes"
          >
            <i class="el-icon-service" style="font-size: 20px" />
            <h3>联系客服</h3>
          </a>
        </li>
        <!-- <li @click="handleFeedBack">
					<svg-icon icon-class="edit" />
					<h3>用户反馈</h3>
				</li> -->
        <li class="show-xcx-pic">
          <!-- <svg-icon icon-class="people" /> -->
          <!-- <h3>小程序</h3> -->
          <!-- <div class="imgBox"> -->
          <!-- :src="require('@/assets/dash_common/service.png')" -->
          <img :src="require('@/assets/xcx.png')" alt="" class="wxPic" />
          <!-- <el-image
						style="width: 100%; height: 100%"
						fit="contain"
						:src="require('@/assets/dash_common/service.png')"
					/> -->
          <!-- </div> -->
          <h4>
            <div
              class="qr-wrap"
              :style="{ 'background-image': `url(${img2})` }"
            />
          </h4>
        </li>
        <li class="show-er-wei-pic">
          <p>
            <!-- <svg-icon icon-class="component" /> -->
            <img :src="require('@/assets/gzh.png')" alt="" class="wxPic1" />
          </p>
          <h4>
            <div
              class="qr-wrap"
              :style="{ 'background-image': `url(${img1})` }"
            />
          </h4>
        </li>
        <li class="to-top" @click="handleBackToTop">
          <svg-icon icon-class="top" />
          <p>TOP</p>
        </li>
      </ul>
    </div>
    <el-dialog
      custom-class="sg-login-dialog"
      :visible.sync="dialogVisible"
      title="请先登录"
      width="400px"
    >
      <login></login>
    </el-dialog>
  </div>
</template>
<script>
import Login from "@/components/Login";
import { mapGetters } from "vuex";

export default {
  components: {
    Login,
  },
  data() {
    return {
      active: "",
      img1: require("@/assets/gzerw.jpg"),
      img2: require("@/assets/peiqi_xcx.jpg"),

      dialogVisible: false,
    };
  },

  computed: {
    ...mapGetters(["cartNum", "token"]),

    // activeObj(){
    //   return {
    //     display:active=='service'?'':'none'
    //   }
    // }
  },
  created() {
    // console.log("RightPanel")
    // this.$store.dispatch('merchant/getCartNum')
  },
  methods: {
    handleLogin() {
      this.dialogVisible = true;
    },
    handleCart() {
      if (this.handleIsLogin()) return;
      this.$router.push("/cart");
    },
    handleBasket() {
      if (this.handleIsLogin()) return;
    },
    handleMessage() {
      if (this.handleIsLogin()) return;
    },
    handleContact() {
      if (this.handleIsLogin()) return;
    },
    handleFeedBack() {
      if (this.handleIsLogin()) return;
    },
    handleBackToTop() {
      var timer = setInterval(function () {
        let osTop =
          document.documentElement.scrollTop || document.body.scrollTop;
        let ispeed = Math.floor(-osTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          osTop + ispeed;
        if (osTop === 0) {
          clearInterval(timer);
        }
      }, 60);
    },
    handleIsLogin() {
      // if (this.$route.path.indexOf("/") > -1) {
      if (!this.token) {
        this.handleLogin();
        return true;
      }
      return false;
    },
    handlehover(flag) {},
  },
};
</script>
<style lang="scss" scoped>
.right-cart-box__0f6c66 > li h3,
.right-cart-box__0f6c66 > li h4 {
  position: absolute;
  top: 0;
  left: -100px;
  width: 100px;
  height: 36px;
  border-radius: 3px 0 0 3px;
  color: #fff;
  background: #ff4f1a;
  overflow: hidden;
  line-height: 36px;
  white-space: nowrap;
  text-align: center;
}
.right-cart-container {
  position: fixed;
  top: 0;
  right: 0;
  width: 36px;
  height: 100%;
  background: #1a1a1a;
  z-index: 99;
  color: #fff;
  .right-cart-box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    margin: auto;
    color: #fff;
    text-align: center;
    width: 100%;
    top: 0;
    bottom: 0;
    height: 80%;
    padding: 0;
    .line-text {
      display: inline-block;
      width: 20px;
      margin: 6px auto;
    }
    .mini-cart {
      margin-top: 0;
      line-height: inherit;
      position: relative;
      box-sizing: border-box;
      min-height: 36px;
      padding: 0 6px;
      cursor: pointer;
      .right-cart-number {
        position: absolute;
        top: 2px;
        right: 4px;
        box-sizing: border-box;
        min-width: 16px;
        height: 16px;
        padding: 0 4px;
        border-radius: 50px;
        color: #fff;
        background: #ff4f1a;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
      }
    }
    .parts-basket {
      line-height: inherit;
      .right-basket-icon {
        font-size: 20px;
      }
    }
    .show-er-wei-pic {
      p {
        width: 24px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
      }
    }

    .show-er-wei-pic,
    .show-xcx-pic {
      // position: relative;
      .wxPic {
        position: absolute;
        width: 20px;
        height: auto;
        line-height: 36px;
        /* vertical-align: middle; */
        -o-object-fit: cover;
        object-fit: cover;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .wxPic1 {
        position: absolute;
        width: 20px;
        height: auto;
        line-height: 36px;
        /* vertical-align: middle; */
        -o-object-fit: cover;
        object-fit: cover;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        // margin: 0 auto;
        // width: 20px;
        // height: auto;
        // line-height: 36px;
        // vertical-align: text-top;
        // object-fit: cover;
      }
      h4 {
        bottom: 0;
        // top: -64px;
        // top: -64px;
        top: -84px;
        .qr-wrap {
          // display: none;
          position: relative;
          padding: 5px;
          margin: 10px;
          height: calc(100% - 20px);

          // background-color: #fff;
          // background: url("~@/assets/gzerw.jpg") no-repeat;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
          // .qr {
          //   position: absolute;
          //   width: 100%;
          //   height: 100%;
          //   background: url("~@/assets/gzerw.jpg") no-repeat;
          //   background-size: cover;
          // }
          // background: #fff;

          // img{
          //   width: 100%;

          // }
        }
        // width: 120px;
      }
      &:hover {
        h4 {
          left: -120px;
          width: 120px;
          // .qr-wrap {
          //   display: block;
          // }
        }
      }
    }
    .to-top {
      line-height: inherit;
    }

    > li {
      position: relative;
      box-sizing: border-box;
      min-height: 36px;
      padding: 0 6px;
      margin-top: 4px;
      line-height: 36px;
      cursor: pointer;
      &:hover {
        background: #ff4f1a;
        .right-cart-number {
          color: #ff4f1a;
          background-color: #fff;
        }
        h3,
        h4 {
          left: -100px;
          // left: auto;
          // right: 36px;
          // min-width: 100px;
          width: 100px;
          // display: block;
          //  background: #ff4f1a;
        }
      }
      //   list-style: none;
      > div {
        width: 24px;
        padding: 16px 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.3);
      }
      h3,
      h4 {
        // display: none;
        // display: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        min-height: 36px;
        border-radius: 3px 0 0 3px;
        color: #fff;
        // background-color: transparent;
        background: #ff4f1a;
        overflow: hidden;
        line-height: 36px;
        white-space: nowrap;
        text-align: center;
        transition: left 0.3s ease-out, width 0.3s ease-out;
        // transition: width 1s ease-out;
      }
    }
  }
}
</style>
<style lang="scss">
.sg-login-dialog {
  .el-dialog__header {
    padding: 10px 12px;
    background-color: #f2f4f5;
    position: relative;
    .el-dialog__headerbtn {
      top: 50%;
      transform: translateY(-50%);
    }
    .el-dialog__title {
      color: #666;
      font-size: 16px;
    }
  }
  .el-dialog__body {
    padding-top: 0;
  }
}
</style>
